import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=37ef801e"
import script from "./SmsList.vue?vue&type=script&lang=js"
export * from "./SmsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports